import { Badge } from '@/shared/components/ui/badge';
import { vettingStatusCopy } from '../utils/vettingCopy';
import type { VettingCheckResolution, VettingCheckResult, VettingCheckStatus } from '../types/vetting.types';

type VettingStatusBadgeProps = {
  status: VettingCheckStatus;
  result?: VettingCheckResult;
  resolution?: VettingCheckResolution;
};

export function VettingStatusBadge({ status, result, resolution }: VettingStatusBadgeProps) {
  const { label, className } = vettingStatusCopy(status, result ?? null, resolution);
  return <Badge className={`border-transparent ${className}`}>{label}</Badge>;
}
